import React from 'react';
import Modal from '../../../../components/Modal';

const StatusUpdateModal = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
  orderToUpdate,
  statusToUpdate,
  getStatusInfo
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirmer le changement de statut"
      onSubmit={onSubmit}
      submitLabel="Confirmer"
      isSubmitting={isSubmitting}
      size="md"
    >
      <div className="py-4">
        <div className="flex items-center justify-center text-amber-500 mb-4">
          <svg className="h-12 w-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>

        <h3 className="text-lg font-medium text-center text-gray-900 mb-2">
          Modifier le statut de la commande
        </h3>

        {orderToUpdate && statusToUpdate && (
          <div className="text-center mb-4">
            <p className="text-sm text-gray-600 mb-3">
              Êtes-vous sûr de vouloir modifier le statut de la commande
              <span className="font-semibold"> #{orderToUpdate.id} </span>
              de
              <span className="font-semibold"> {getStatusInfo(orderToUpdate.etat).label} </span>
              à
              <span className="font-semibold"> {getStatusInfo(statusToUpdate).label}</span> ?
            </p>

            <div className="flex items-center justify-center space-x-3 mt-4">
              <div className="flex items-center px-3 py-2 rounded-full bg-gray-100">
                <span className={`h-2 w-2 rounded-full mr-2 ${getStatusInfo(orderToUpdate.etat).color.replace('text-', 'bg-').split(' ')[1]}`}></span>
                <span className="text-sm">{getStatusInfo(orderToUpdate.etat).label}</span>
              </div>

              <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 011.414-1.414l4 4a1 0 01-1.414 0l-4-4a1 0 010-1.414z" clipRule="evenodd" />
              </svg>

              <div className="flex items-center px-3 py-2 rounded-full bg-gray-100">
                <span className={`h-2 w-2 rounded-full mr-2 ${getStatusInfo(statusToUpdate).color.replace('text-', 'bg-').split(' ')[1]}`}></span>
                <span className="text-sm">{getStatusInfo(statusToUpdate).label}</span>
              </div>
            </div>
          </div>
        )}

        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mt-4">
          <div className="flex">
            <svg className="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <div className="ml-3">
              <p className="text-sm text-amber-700">
                Ce changement de statut sera visible par le client et pourrait déclencher des notifications automatiques.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StatusUpdateModal;